import { Component, EventEmitter, Input, Output } from '@angular/core'

import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { UpdateRolePayload, ScopeElementsConfig } from '../models'
import { trackById } from '@app/shared/utils/utils'
import { Department } from '@app/features/scoping/models/department.model'

@Component({
  selector: 'scope-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss'],
})
export class DepartmentsComponent {
  @Input() config: ScopeElementsConfig
  @Input() level: number
  @Input() component: ScopeComponent
  @Input() departments: Department[]

  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  protected readonly trackById = trackById

  getDepartments = (): Department[] =>
    this.component.departments.filter((d) =>
      this.config?.isChangeRequest ? this.config?.showDiff || !d.isRemoved : true
    )
}
